import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-btn {
    margin-bottom: 15px;
    cursor: pointer;
    background-color: #001529;
    color: white;
  }
  .ant-btn:hover {
    background: transparent;
    border: 2px solid #001529;
    color: black;
  }
  .add-level-button {
    background: #3a96b8;
  }
  .add-level-button:hover {
    background: transparent;
    border: 2px solid #3a96b8;
  }

  .ant-tree-list {
    background: #e1eff6;
  }
  .edit-icon {
    padding-bottom: 20px;
    font-size: 18px;
    padding-left: 5px;
  }
  .button {
    margin-bottom: 15px;
    cursor: pointer;
    background-color: #001529;
    width: 100%;
    color: white;
    text-align: center;
    padding: 15px;
    font-size: 16px;
    border-radius: 5px;
  }
`;
